<template>
	<div class="tc-all-day"
		v-bind:class="classAllDayOuter"
		v-statemachine= "sm_allday"
	>
		<div class="schedule-all-day"
			v-bind:class="classAllDay">
		</div>
		<div class="all-day-info"
			v-bind:class="classTaskInfo"
			v-bind:style="styleTaskInfo"
			v-statemachine= "sm_allday_info">
			{{taskInfo}}
		</div>
	</div>
</template>
<script>
import MouseState from '../../classes/MouseState';
import MouseStateMachine from '../../classes/MouseStateMachine';
import clonedeep from 'lodash/cloneDeep';

export default {
	name: 'TCAllDay',
	props: [
		"item",
		"count",
		"schedules",
		"name",
		"isEditable",
		"isExpanded",
	],
	data: function() {
		const state_nop = new MouseState({});
		
		return {
			state_nop: state_nop,
			sm_allday: new MouseStateMachine(state_nop),
			sm_allday_info: new MouseStateMachine(state_nop),
		};
	},
	mounted: function() {
		this.sm_allday_info.next(this.defaultStateAlldayInfo());
		this.sm_allday.next(this.defaultStateAllDay());
	},
	methods: {
		schedulePeriod: function() {
			if(this.item.all_day)
				return '';
			
			if (!this.item.isSingleDay)
				return this.item.begin.strftimeDCL('%m月%d日 %H:%M') + '～' + this.item.end.strftimeDCL('%m月%d日 %H:%M');
			
			return '';
		},
		defaultStateAllDay: function() {
			if (!this.isEditable)
				return this.state_nop;
			
			const state_default = new MouseState({
				longpress: (e) => {
					e.stopPropagation();
				},
			});
			
			return state_default;
		},
		defaultStateAlldayInfo: function() {
			if (!this.isEditable)
				return this.state_nop;
			
			const state_default = new MouseState({
				longpress: (e) => {
					e.stopPropagation();
				},
				click: () => {
					this.$emit('update_schedule_info', {
															target: clonedeep(this.item), 
															schedules: this.schedules,
														});
				},
			});
			return state_default;
		},
	},
	computed: {
		classAllDayOuter: function() {
			let classes = new Array();
				if(!this.isExpanded){
					classes.push('parent');
				}
			return classes;
		},
		classAllDay: function() {
			let classes = new Array();
			if(this.$store.getters['chart/isDisplayMemberList']) {
				if(!this.item.isAssociatedProject)
					classes.push('task');
				else
					classes.push('task_project');
			} else {
				if(this.item.isTaskSchedule)
					classes.push('task_project');
				else
					classes.push('project');
			}
			
			return classes;
		},
		classTaskInfo: function() {
			let classes = new Array();
			if(this.$store.getters['chart/isDisplayMemberList']) {
				if(!this.item.isAssociatedProject)
					classes.push('info_task');
				else
					classes.push('info_task_project');
			} else {
				if(this.item.isTaskSchedule)
					classes.push('info_task_project');
				else
					classes.push('info_project');
			}
			return classes;
		},
		styleTaskInfo: function() {
			return {
				"margin-left": this.hscroll + "px",
			};
		},
		taskInfo: function() {
			let name = this.name;
			if (this.$store.getters['chart/isDisplayMemberList']
				&& !this.isExpanded) {
					let task = this.$store.getters.task(this.item.task_code)
					if (task !== null)
						name = task.name;
			}
			
			if(this.count > 0)
				return name + '　他' + this.count + '件';
			
			let period = this.schedulePeriod();
			return name + '　終日　' + period;
		},
		hscroll: function() {
			return this.$store.getters['chart/hscroll'];
		},
	},
	watch: {
		isEditable: function() {
			this.sm_allday_info.next(this.defaultStateAlldayInfo());
			this.sm_allday.next(this.defaultStateAllDay());
		},
	},
};
</script>
<style>
	.tc-all-day {
		padding-top: 1px;
		display: inline-block;
		height: 48px;
		width: 100%;
		position: absolute;
	}
	.tc-all-day.parent {
		padding-top: 0px !important;
		height: 49px;
	}
	
	.schedule-all-day {
		position: absolute;
		height: 100%;
		width:100%;
		opacity: .3;
	}
	.schedule-all-day.project {
		background-color: orchid;
	}
	.schedule-all-day.task {
		background-color: mediumpurple;
	}
	.schedule-all-day.task_project {
		background-color: lightgreen;
	}
	.info_project {
		color: mediumorchid;
	}
	.info_task {
		color: mediumpurple;
	}
	.info_task_project {
		color: mediumaquamarine;
	}
	.all-day-info {
		position: absolute;
		margin-top: 15px;
		padding-left: 10px;
		width: auto;
		height:auto;
	}
</style>
